import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { linkService } from "../../link-service";
import { CodatConnectionsProps as CodatProps } from "@codat/sdk-connections";

export interface CodatConnectionsProps {
  onClose: () => void;
}

const initialize = (
  sdkUrl: string,
  target: HTMLElement,
  props: CodatProps & { baseUrl: string }
) => {
  return import(/* webpackIgnore: true */ sdkUrl).then(
    ({ CodatConnections }) =>
      new CodatConnections({
        target,
        props,
      })
  );
};

const isProduction = window.location.host === "link-demo.codat.io";
const apiUrl = isProduction
  ? "https://link-api.codat.io/connectionManagement"
  : "https://link-api-integration.codat.io/connectionManagement";

const initializeConnectionSdk = async (
  sdkUrl: string,
  target: HTMLElement,
  userId: string,
  onClose: () => void
) => {
  const response = await linkService.getAccessToken(userId);
  try {
    await initialize(sdkUrl, target, {
      accessToken: response.accessToken,
      onReconnect: () => alert("On reconnect callback!!"),
      onDisconnect: () => alert("On disconnect callback!!"),
      onError: () => alert("On error callback!!"),
      onClose,
      baseUrl: apiUrl,
    });
  } catch (error) {
    alert("Error initializing Connections SDK");
  }
};

export const CodatConnections = ({ onClose }: CodatConnectionsProps) => {
  const componentMount = useRef<null | HTMLDivElement>(null);
  const params = useParams();

  useEffect(() => {
    const sdkUrl = "https://connections-sdk.codat.io";
    const target = componentMount.current;

    if (target && target.children.length === 0 && params["userId"]) {
      initializeConnectionSdk(sdkUrl, target, params["userId"], onClose);
    }
  }, [componentMount]);

  return (
    <div
      style={{
        width: "460px",
        height: "840px",
        margin: "1rem 0",
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
      }}
      ref={componentMount}
    />
  );
};
